<ng-template #content>
  <div
    class="desktop-content-padding"
    [class.mobile-content-padding]="isMobileResolution">
    <ion-row class="progress-bar-row">
      <ng-container *ngFor="let item of progressBars">
        <ion-col class="identification-progress-bar">
          <mat-progress-bar [mode]="item.mode" [value]="item.value">
          </mat-progress-bar>
        </ion-col>
      </ng-container>
    </ion-row>
    <tidy-row [align]="'center'" class="img-row">
      <div class="circle-div">
        <tidy-image
          [src]="currentIdentificationStep.icon"
          class="step-img"></tidy-image>
      </div>
    </tidy-row>
    <tidy-row [align]="'center'">
      <tidy-text class="step-title" [header]="currentIdentificationStep.title">
      </tidy-text>
    </tidy-row>
    <tidy-row [align]="'center'">
      <tidy-text [body]="currentIdentificationStep.subtitle"> </tidy-text>
    </tidy-row>
    <ng-container *ngIf="currentIdentificationStep === identificationSteps[0]">
      <div style="padding-top: 1rem;">
        <tidy-alert severity="warning" style="margin-bottom: 1rem; border: 2px solid orange; padding: 10px;">
          <tidy-row [align]="'center'" style="margin-bottom: 0.5rem;">
            <tidy-image
              [src]="'assets/svg/alert.svg'"
              class="body-size"
              style="margin-right: 8px;">
            </tidy-image>
            <tidy-text style="font-weight: bold; font-size: 1.1em;">
              Important: For US-based users
            </tidy-text>
          </tidy-row>
          <tidy-text [body]="'A Valid United States ID Document is required:'" style="font-weight: bold;"></tidy-text>
          <ul>
            <li>US Issued Passport</li>
            <li>US / US State Driver's License</li>
            <li>US Issued ID Card</li>
          </ul>
          <tidy-text [body]="'NON-US DOCUMENTS ARE NOT ACCEPTED. IF YOU UPLOAD THEM YOUR ACCOUNT WILL BE SHUT DOWN PENDING A MANUAL REVIEW.'"
                       style="color: red; font-weight: bold; margin-top: 0.5rem;"></tidy-text>
        </tidy-alert>
      </div>

      <div style="margin-top: 1.5rem; margin-bottom: 1.5rem;">
        <tidy-row [align]="'start'" style="flex-direction: column;">
          <tidy-text [label]="'What best describes you? (Required)'" style="margin-bottom: 0.5rem; font-weight: bold;"></tidy-text>
          <ng-container *ngIf="isMobileResolution">
            <ion-item lines="none" style="--padding-start: 0; --inner-padding-end: 0; --background: transparent; --border-color: transparent;">
              <ion-label position="floating" style="--color: rgba(0, 0, 0, 0.6);">Select your ID verification option</ion-label>
              <ion-select
                interface="action-sheet"
                (ionChange)="onIdOptionChange($event.detail.value)"
                style="width: 100%; --padding-start: 0; --padding-end: 10px; --padding-top: 8px; --padding-bottom: 8px; border-bottom: 1px solid #e4e8eb; --icon-space: 24px;">
                <ion-select-option value="not_in_us">Not using this in the US at all</ion-select-option>
                <ion-select-option value="valid_us_id">I'm uploading a valid US Passport, US Driver's License, or US ID Card</ion-select-option>
                <ion-select-option value="no_valid_us_id">I don't have a valid US Passport, US Driver's License, or US ID Card</ion-select-option>
              </ion-select>
            </ion-item>
          </ng-container>
          <ng-container *ngIf="!isMobileResolution">
            <tidy-select
              [label]="'Select your ID verification option'"
              [items]="[
                { viewValue: 'Not using this in the US at all', value: 'not_in_us' },
                { viewValue: 'I\'m uploading a valid US Passport, US Driver\'s License, or US ID Card', value: 'valid_us_id' },
                { viewValue: 'I don\'t have a valid US Passport, US Driver\'s License, or US ID Card', value: 'no_valid_us_id' }
              ]"
              (optionChange)="onIdOptionChange($event)">
            </tidy-select>
          </ng-container>
        </tidy-row>
      </div>

      <ng-container *ngIf="selectedIdOption === 'no_valid_us_id'">
        <div style="margin-top: 1rem;">
          <tidy-alert severity="error" style="border: 2px solid red; padding: 10px;">
            <tidy-row [align]="'center'">
              <tidy-image
                [src]="'assets/svg/alert.svg'"
                class="body-size"
                style="margin-right: 8px;">
              </tidy-image>
              <tidy-text [body]="'This is not supported at this time. Please contact concierge@tidy.com if you feel this should be supported.'"></tidy-text>
            </tidy-row>
          </tidy-alert>
        </div>
      </ng-container>

    </ng-container>
    <tidy-row
      class="step-button-row"
      [align]="'center'"
      *ngIf="currentIdentificationStep.displayButton">
      <tidy-button
        [text]="currentIdentificationStep.buttonText"
        [action]="currentIdentificationStep.action.bind(this)"
        class="primary">
      </tidy-button>
    </tidy-row>

    <ng-container *ngIf="identificationError">
      <tidy-alert>
        <tidy-row [align]="'center'">
          <tidy-text [body]="'<b>Error: </b>'">
          </tidy-text>
          <tidy-text [body]="identificationError?.reason">
          </tidy-text>
        </tidy-row>
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Verify again.'"
            class="link"
            (action)="this.goToVerificationPage()">
          </tidy-text>
        </tidy-row>
      </tidy-alert>
    </ng-container>
  </div>
</ng-template>

<ion-content *ngIf="isMobileResolution">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ion-content>

<ng-container *ngIf="!isMobileResolution">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>
